import { render, staticRenderFns } from "./WithdrawalDetails.vue?vue&type=template&id=3a1e9fa7&"
import script from "./WithdrawalDetails.vue?vue&type=script&lang=js&"
export * from "./WithdrawalDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports